import { addDays, format, parse } from "date-fns";
import { END_DATE, START_DATE } from "src/constants/filter";
import { FilterInput } from "src/types/report";

// Set to 0 to disable offset, or remove calls to applyFilterDateOffset entirely.
const FILTER_DATE_OFFSET_DAYS: number = 0;

const DATE_FORMAT = "yyyy-MM-dd";

export const applyFilterDateOffset = (
  fields: Record<string, string | number>,
): Record<string, string | number> => {
  if (FILTER_DATE_OFFSET_DAYS === 0) return fields;
  const shift = (val: string | number) =>
    format(
      addDays(
        parse(String(val), DATE_FORMAT, new Date()),
        FILTER_DATE_OFFSET_DAYS,
      ),
      DATE_FORMAT,
    );
  return {
    ...fields,
    ...(fields.start_date ? { start_date: shift(fields.start_date) } : {}),
    ...(fields.end_date ? { end_date: shift(fields.end_date) } : {}),
  };
};

export const getInitialValues = (fields: FilterInput[]) =>
  fields.reduce<Record<string, string | number>>((acc, field) => {
    if (field.key === "start_date") {
      acc[field.key] = START_DATE;
      return acc;
    }

    if (field.key === "end_date") {
      acc[field.key] = END_DATE;
      return acc;
    }

    if (
      field.control_type === "tabs" &&
      field.static_options &&
      field.static_options.length > 0
    ) {
      acc[field.key] = field.default_value ?? "";
      return acc;
    }

    acc[field.key] = field.default_value ?? "";
    return acc;
  }, {});
